module.exports = __webpack_public_path__ + "static/img/undefined.b3a4759.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/undefined.png
// module id = 6GdD
// module chunks = 1